import {Injectable} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";

import {CLIMATELOG_ROOT} from "./climatelogData";
import {UrlBuilder} from "../url-builder/url.builder";


@Injectable({
  providedIn: 'root'
})

export class ClimatelogDataService {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }


  GetData(logLevel: number): Observable<CLIMATELOG_ROOT> {
    this.uiUrl = this.url.GetClimateLogUrl() + "/" + logLevel;
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<CLIMATELOG_ROOT>(this.uiUrl);
  }
}



